<template>
  <div>
    <PageAllow controller="ExamineMaterialAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 入库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 按钮 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'DistributionMaterialAnalyze',
                    'detailExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                href=""
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("MaterialExamine.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterial v-model="materialSelected" />
                </v-col>
                <!-- 销售 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherAlliances v-model="alliancesSelected" />
                </v-col>
                <!-- 客户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops v-model="shopsSelected" />
                </v-col>
                <!-- 分组 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    settings && settings.report_hide_search_district_tree == 2
                  "
                >
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStocks v-model="stocksSelected" />
                </v-col>
                <!-- 线路 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistributionUsers
                    v-model="distributionUserSelected"
                    :searcherStocks="options.stock_ids"
                  />
                </v-col>
                <!--                &lt;!&ndash; 状态 &ndash;&gt;-->
                <!--                <v-spacer />-->
                <!--                <v-col cols="12" sm="6" md="4">-->
                <!--                  &lt;!&ndash; 使用 &ndash;&gt;-->
                <!--                  <SearcherDistributionStatus-->
                <!--                    :items="$consts.distribution.distribution_status"-->
                <!--                    v-model="options.status"-->
                <!--                    :label="$t('DistrictsMaterialSales.Fields.status')"-->
                <!--                  />-->
                <!--                </v-col>-->
                <!-- 状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('MaterialExamine.status.title')"
                    :items="$consts.examine.status"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.abnormal_flgs"
                    :label="$t('MaterialExamine.abnormalFlgs.title')"
                    :items="$consts.examine.abnormal_flgs"
                  />
                </v-col>
                <!-- 商品销售类型 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSingleStatus
                    mandatory
                    v-model="options.auto_flg"
                    :label="$t('auto_flg.ObjectName')"
                    :items="$consts.autoFlg"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="districts_material_sales"
            :page.sync="current_page"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td :colspan="settings && settings.report_hide_search_district_tree == 1 ? 5 : 6">
                  <v-btn
                    v-if="settings && settings.report_hide_search_district_tree == 1"
                    small
                    outlined
                    color="info"
                    class="px-2 me-2"
                    :disabled="!districtID"
                    @click.stop="$emit('to-parent-district')"
                  >
                    <v-icon x-small class="pe-1">fa-reply</v-icon>
                    {{ $t("District.return") }}
                  </v-btn>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <!-- <td></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ material_order_total_num | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money") }}
                    {{ material_order_total_price | formatMoney }}</span
                  >
                </td> -->
                <td></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ material_examine_total_num | formatTwoDot }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ material_unexamine_total_num | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ material_examine_total_price | formatMoney }}
                  </span>
                </td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    <v-btn
                      v-if="settings && settings.report_hide_search_district_tree == 1"
                      small
                      outlined
                      color="info"
                      class="px-2"
                      @click.stop="$emit('to-parent-district')"
                    >
                      <v-icon x-small class="pe-1">fa-reply</v-icon>
                      {{ $t("District.return") }}
                    </v-btn>
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialExamine.Fields.order_num_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ material_order_total_num | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialExamine.Fields.order_price_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ material_order_total_price | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialExamine.Fields.num_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ material_examine_total_num | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialExamine.Fields.price_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ material_examine_total_price | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.title="{ header }">
              <v-icon x-small>fa-map-marked-alt</v-icon>
              {{ header.text }}
              <v-icon x-small>fa-store</v-icon>
            </template>
            <template v-slot:item.title="{ item }">
              <span
                :class="!item.shop_name ? 'info--text' : ''"
                @click.stop="
                  if (!item.shop_name) $emit('change-district', item.district);
                "
              >
                <v-icon :color="!item.shop_name ? 'info' : ''" x-small>{{
                  typeof item.shop_name == "undefined"
                    ? "fa-map-marked-alt"
                    : "fa-store"
                }}</v-icon>
                {{
                  typeof item.shop_name == "undefined"
                    ? item.district.name
                    : item.shop_name
                }}
                <v-icon
                  :color="!item.shop_name ? 'info' : ''"
                  v-if="!item.shop_name"
                  x-small
                  >fa-angle-double-right</v-icon
                >
              </span>
            </template>
            <template v-slot:item.material_name="{ item }">
              {{ item.material_name }}
            </template>
            <template v-slot:item.standard_name="{ item }">
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </template>
            <template v-slot:item.price="{ item }"
              >{{ $t("Global.money") }}
              {{ item.price }}
            </template>
            <template v-slot:item.order_num_sum="{ item }">
              {{ item.order_num_sum | formatTwoDot }}
            </template>
            <template v-slot:item.order_price_sum="{ item }"
              >{{ $t("Global.money") }}
              {{ item.order_price_sum | formatMoney }}
            </template>
            <template v-slot:item.num_sum="{ item }">
              {{ item.num_sum | formatTwoDot }}
            </template>
            <template v-slot:item.unexamine_sum="{ item }">
              {{ item.unexamine_sum | formatTwoDot }}
            </template>
            <template v-slot:item.price_sum="{ item }"
              >{{ $t("Global.money") }}
              {{ item.price_sum | formatMoney }}
            </template>
            <template v-slot:item.average_price="{ item }"
              >{{ $t("Global.money") }}
              {{ (item.price_sum / item.num_sum) | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";

import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import ExamineMaterialAnalyze from "@/api/examine_material_analyze";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import SearcherDistributionUsers from "@/components/plugins/SearcherDistributionUsers";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherSingleStatus from "@/components/plugins/SearcherSingleStatus";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  datetimeRadioSelected: "create",
  create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  examine_time_from: "",
  examine_time_to: "",
  status: [0, 1],
  abnormal_flgs: [0, 1],
  alliance_business_ids: [],
  shop_ids: [],
  distribution_users: [],
  stock_ids: null,
  material_id: [],
  auto_flg: null,
  district_ids: [],
};

export default {
  data: () => ({
    districts_material_sales: [],
    stocksSelected: [],
    materialSelected: null,
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    order_total: 0,
    alliancesSelected: null,
    shopsSelected: null,
    distributionUserSelected: null,
    material_order_total_num: 0,
    material_order_total_price: 0,
    material_examine_total_num: 0,
    material_unexamine_total_num: 0,
    material_distribution_total_num: 0,
    material_examine_total_price: 0,
    current_page: 1,
    DistrictsSelected: [],
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherMaterial,
    SearcherStocks,
    SearcherAlliances,
    SearcherShops,
    SearcherDistributionUsers,
    SearcherStatus,
    SearcherSingleStatus,
    SearcherDistrictsWithDescendants,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialExamine"),
        disabled: false,
        href: "/examine-material-analyze",
      },
      {
        text: i18n.t("Nav.materialExamineDetail"),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "create",
        text: i18n.t("MaterialExamine.Fields.created_date"),
      },
      {
        key: "examine",
        text: i18n.t("MaterialExamine.Fields.examine_date"),
      },
    ],
    headers() {
      var headers = []
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        headers.push(
          {
            text: i18n.t("DistrictsMaterialSales.TableHeaders.title"),
            align: "start",
            sortable: false,
            value: "title",
          },
        )
      } else if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 2
      ) { 
        headers.push(
        {
          text: i18n.t("MaterialExamine.Fields.shop_code", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("MaterialExamine.Fields.shop_name", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        )
      }
      headers.push(
        {
          text: i18n.t("MaterialExamine.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("MaterialExamine.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("MaterialExamine.Fields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("MaterialExamine.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        // // 均价
        // {
        //   text: i18n.t("DistrictsMaterialSales.Fields.price"),
        //   align: "end",
        //   sortable: false,
        //   value: "price",
        // },
        // // 下单量
        // {
        //   text: i18n.t("DistrictsMaterialSales.Fields.order_num_sum"),
        //   align: "end",
        //   sortable: false,
        //   value: "order_num_sum",
        // },
        // // 下单金额
        // {
        //   text: i18n.t("DistrictsMaterialSales.Fields.order_price_sum"),
        //   align: "end",
        //   sortable: false,
        //   value: "order_price_sum",
        // },
        // 配送均价
        {
          text: i18n.t("MaterialExamine.Fields.averagePrice"),
          align: "end",
          sortable: false,
          value: "average_price",
        },
        // 验收量
        {
          text: i18n.t("MaterialExamine.Fields.num_sum"),
          align: "end",
          sortable: false,
          value: "num_sum",
        },
        // 待验收量
        {
          text: i18n.t("MaterialExamine.Fields.unexamine_sum"),
          align: "end",
          sortable: false,
          value: "unexamine_sum",
        },
        // 验收金额
        {
          text: i18n.t("MaterialExamine.Fields.price_sum"),
          align: "end",
          sortable: false,
          value: "price_sum",
        },
      )
      return headers;
    },

    ...mapState(["districtID", "settings"]),
  },

  mounted() {
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );

    this.$commonUtils
      .loadOptions("examine_material_sales", [
        "stocksSelected",
        "alliancesSelected",
        "shopsSelected",
        "distributionUserSelected",
        "materialSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = Object.assign({}, data.options, {
              auto_flg: this.$route.query.auto_flg
                ? parseInt(this.$route.query.auto_flg)
                : 0,
            });
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "distributionUserSelected":
                this.distributionUserSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      this.getExamineMaterialAnalyzeDetailsFromAPI();
    },
    resetSearch() {
      this.stocksSelected = [];
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.distributionUserSelected = [];
      this.DistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.$store.commit("districtID", 0);
    },
    getExamineMaterialAnalyzeDetailsFromAPI() {
      this.loading = true;
      //整理异常状态搜索条件
      if (
        this.options.abnormal_flgs.find((flgs) => flgs == "1") &&
        this.options.abnormal_flgs.length <= 2
      ) {
        this.options.abnormal_flgs.push(2, 3);
      } else if (
        this.options.abnormal_flgs.find((flgs) => flgs == "2") &&
        !this.options.abnormal_flgs.find((flgs) => flgs == "1")
      ) {
        if (
          "0" in this.options.abnormal_flgs &&
          this.options.abnormal_flgs.length == 3
        ) {
          this.options.abnormal_flgs = [0];
        } else {
          this.options.abnormal_flgs = [];
        }
      }
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID ,
        });
      }
      ExamineMaterialAnalyze.fetchOne(this.$route.params.id, options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.districts_material_sales =
              response.data.districts_material_sales;
            this.material_examine_total_num =
              response.data.material_examine_total_num;
            this.material_unexamine_total_num =
              response.data.material_unexamine_total_num;
            this.material_distribution_total_num =
              response.data.material_distribution_total_num;
            this.material_examine_total_price =
              response.data.material_examine_total_price;
            this.current_page = 1;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      //整理异常状态搜索条件
      if (
        this.options.abnormal_flgs.find((flgs) => flgs == "1") &&
        this.options.abnormal_flgs.length <= 2
      ) {
        this.options.abnormal_flgs.push(2, 3);
      } else if (
        this.options.abnormal_flgs.find((flgs) => flgs == "2") &&
        !this.options.abnormal_flgs.find((flgs) => flgs == "1")
      ) {
        if (
          "0" in this.options.abnormal_flgs &&
          this.options.abnormal_flgs.length == 3
        ) {
          this.options.abnormal_flgs = [0];
        } else {
          this.options.abnormal_flgs = [];
        }
      }
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID ,
        });
      }
      ExamineMaterialAnalyze.detailExports(this.$route.params.id, options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getExamineMaterialAnalyzeDetailsFromAPI();
        sessionStorage.setItem(
          "examine_material_sales-options",
          JSON.stringify(this.options)
        );
      },
    },
    districtID: {
      handler() {
        this.getExamineMaterialAnalyzeDetailsFromAPI();
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_id = this.materialSelected
          ? [this.materialSelected.id]
          : [];
        sessionStorage.setItem(
          "examine_material_sales-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },

    // 配送线路
    distributionUserSelected: {
      handler() {
        this.options.distribution_users = this.distributionUserSelected
          ? this.distributionUserSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "examine_material_sales-distributionUserSelected",
          JSON.stringify(this.distributionUserSelected)
        );
      },
    },
    // 仓库
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected.map((e) => e.id);
        sessionStorage.setItem(
          "examine_material_sales-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },

    // 销售
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "examine_material_sales-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "examine_material_sales-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 2)
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          sessionStorage.setItem(
            "examine_material_sales-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },
};
</script>

<style>
</style>